import { useState, useEffect, useMemo } from 'react';
import AdminLayout from '../../layouts/AdminLayout'

import {
    Box, Button, Flex, HStack, Input, Spinner,
    Table, Thead, Tbody, Tr, Th, Td, TableContainer, IconButton,
    useDisclosure,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody, FormControl, FormLabel,
    Select, VStack, Link, Avatar, Text
} from "@chakra-ui/react";
import { FaEdit, FaFileCsv, FaFilePdf } from "react-icons/fa";
import { getVehicleType, getStatus, formatDate } from '../../utils/helper';
import adminService from '../../services/adminService';
import config from '../../constants/config';

import ReactPaginate from "react-paginate";
import { exportToPDF } from '../../utils/pdfExporter';
import { exportToCSV } from '../../utils/csvExporter';

const ITEMS_PER_PAGE = 10;

const AdminVehicle = () => {

    const backendUrl = config.apiBaseUrl;

    const [data, setData] = useState([]);
    const [reasionData, setReasionData] = useState([]);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedDVNo, setSelectedDVNo] = useState(null);
    const [Stat, setStat] = useState(0);
    const [reasionId, setReasionId] = useState(0)
    const [reasionBlock, setReasionBlock] = useState(false)

    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(0);
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");

    useEffect(() => {
        vehicleListing();
        reasionList();
    }, []);

    const vehicleListing = async () => {
        setData([]);
        try {
            const res = await adminService.getVehicleList();
            setData(res.data);
        } catch (error) {
            alert(error.response?.data?.message || "Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    const reasionList = async () => {
        setReasionData([]);
        let param = {
            type: 1
        };

        try {
            const res = await adminService.getReasions(param);
            setReasionData(res.data);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    const handleEdit = (row) => {
        setSelectedDVNo(row.DVNo);
        onOpen();
    };

    const handleChange = (e) => {
        setStat(Number(e.target.value));
        setReasionBlock(false)
        if (Number(e.target.value) === 9) {
            setReasionBlock(true)
        }
    };

    const handleReasion = (e) => {
        setReasionId(Number(e.target.value));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (selectedDVNo > 0 && !isNaN(parseInt(Stat))) {
            let param = {
                DVNo: selectedDVNo,
                Stat: Stat,
                reasionId: reasionId
            };

            if (Stat === 9 && reasionId < 1) {
                alert(`Select Reasion Field`)
                return false;
            }

            try {
                const res = await adminService.updateVehicle(param)
                if (res.statusCode === 200) {
                    onClose();
                    alert(res.message)
                    setSelectedDVNo(0);
                    vehicleListing();
                }
            } catch (error) {
                if (error.response?.status === 401) {
                    alert(error.response.data.message);
                } else {
                    alert("Something went wrong. Please try again.");
                    console.error(error);
                }
            }
        } else {
            alert(`Select Required Field`)
        }
    }

    const filteredData = useMemo(() => {
        let result = [...data];
        if (search) {
            const lowerSearch = search.toLowerCase();
            result = result.filter((item) =>
            (`${item.FName} ${item.LName}`.toLowerCase().includes(lowerSearch) ||
                (item.MobileNo || '').toLowerCase().includes(lowerSearch) ||
                (item.DOB || '').toLowerCase().includes(lowerSearch) ||
                (item.VColor || '').toLowerCase().includes(lowerSearch) ||
                (item.VMake || '').toLowerCase().includes(lowerSearch) ||
                (item.VModel || '').toLowerCase().includes(lowerSearch) ||
                (item.VNo || '').toLowerCase().includes(lowerSearch) ||
                (item.VEngNo || '').toLowerCase().includes(lowerSearch) ||
                (item.VRegNo || '').toLowerCase().includes(lowerSearch) ||
                (item.VInsNo || '').toLowerCase().includes(lowerSearch) ||
                (item.VInsCompany || '').toLowerCase().includes(lowerSearch) ||
                (item.VInsEndDt || '').toLowerCase().includes(lowerSearch) ||
                String(item.Stat).includes(lowerSearch))
            );
        }
        if (sortField) {
            result.sort((a, b) => {
                let aVal = a[sortField] ?? '';
                let bVal = b[sortField] ?? '';

                return sortOrder === "asc" ? aVal > bVal ? 1 : -1 : aVal < bVal ? 1 : -1;
            });
        }
        return result;
    }, [data, search, sortField, sortOrder]);

    const pageCount = Math.ceil(filteredData.length / ITEMS_PER_PAGE);

    const currentData = useMemo(() => {
        const start = page * ITEMS_PER_PAGE;
        return filteredData.slice(start, start + ITEMS_PER_PAGE);
    }, [filteredData, page]);

    const handleSort = (field) => {
        if (sortField === field) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortField(field);
            setSortOrder("asc");
        }
    };

    const handlePageChange = ({ selected }) => {
        setPage(selected);
    };

    const exportCSV = () => {
        // data, filename
        exportToCSV(filteredData, "vehicleList.csv")
    };

    const exportPDF = () => {
        const columns = [
            { label: "DVNo", accessor: "DVNo" },
            {
                label: "Fullname",
                accessor: (item) =>
                    `${item.users.FName} ${item.users.LName}`
            },
            { label: "Mobile", accessor: "users.MobileNo" },
            { label: "VNo", accessor: "VNo" },
            {
                label: "Vehicle",
                accessor: (item) =>
                    `${item.VMake} ${item.VModel} ${item.VColor}`
            },
            { label: "Engine", accessor: "VEngNo" },
            { label: "RegNo", accessor: "VRegNo" },
            { label: "RegDt", accessor: "VRegDt" },
            { label: "InsNo", accessor: "VInsNo" },
            { label: "InsCompany", accessor: "VInsCompany" },
            { label: "InsEndDt", accessor: "VInsEndDt" },
        ];

        exportToPDF({
            data: filteredData,      // your actual data array
            columns,
            fileName: "vehicleList.pdf"
        });
    };

    return (
        <AdminLayout>
            <Box maxW="1000px" mx="auto" px={4}>
                <Box
                    bg="white"
                    p={6}
                    rounded="xl"
                    boxShadow="md"
                    border="1px solid"
                    borderColor="gray.200"
                >
                    <Flex justify="space-between" mb={4} flexWrap="wrap" gap={4}>
                        <Input
                            placeholder="Search..."
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setPage(0);
                            }}
                            maxW="300px"
                            size="sm"
                        />
                        <HStack>
                            <Button
                                size="sm"
                                colorScheme="blue"
                                leftIcon={<FaFileCsv />}
                                onClick={exportCSV}
                            >
                                CSV
                            </Button>
                            <Button
                                size="sm"
                                colorScheme="red"
                                leftIcon={<FaFilePdf />}
                                onClick={exportPDF}
                            >
                                PDF
                            </Button>
                        </HStack>
                    </Flex>

                    {loading ? (
                        <Box textAlign="center" py={10}>
                            <Spinner size="xl" />
                            <Text mt={4}>Loading vehicles...</Text>
                        </Box>
                    ) : (
                        <>
                            <TableContainer overflowX="auto">
                                <Table size="sm" variant="simple">
                                    <Thead bg="gray.100">
                                        <Tr>
                                            <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("Fname")}>Name</Th>
                                            <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("VMake")}>Make</Th>
                                            <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("VModel")}>Model</Th>
                                            <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("VNo")}>No</Th>
                                            <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("VTyp")}>Type</Th>
                                            <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("VEngNo")}>Eng No</Th>
                                            <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("VRegNo")}>Reg No</Th>
                                            <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("VInsCompany")}>Insurance</Th>
                                            <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("uId")}>Stat</Th>
                                            <Th px={2} py={1}>Files</Th>
                                            <Th px={2} py={1}>Action</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        {currentData.length > 0 ? (
                                            currentData.map((row) => (
                                                <Tr key={row.DVNo}>
                                                    <Td>
                                                        <Flex align="center">
                                                            <Avatar
                                                                src={`${backendUrl}/vehicle/${row.vehiclePic}`}
                                                                name={`${row.VMake}`}
                                                                size="md"
                                                                mr={4}
                                                            />
                                                            <Box>
                                                                <Text fontWeight="bold">
                                                                    {row.users?.FName} {row.users?.LName}
                                                                </Text>
                                                                <Text color="gray.600">{row.users?.MobileNo}</Text>
                                                                <Text color="gray.500" fontSize="sm">
                                                                    {formatDate(row.users?.DOB)}
                                                                </Text>
                                                            </Box>
                                                        </Flex>
                                                    </Td>

                                                    <Td>{row.VMake}</Td>
                                                    <Td>{row.VModel}</Td>
                                                    <Td>{row.VNo}</Td>
                                                    <Td>
                                                        <Box display="flex" flexDirection="column">
                                                            <Text>{row.VColor}</Text>
                                                            <Text>{getVehicleType(row.VTyp)}</Text>
                                                        </Box>
                                                    </Td>
                                                    <Td>{row.VEngNo}</Td>
                                                    <Td>
                                                        <Box display="flex" flexDirection="column">
                                                            <Text>{row.VRegNo}</Text>
                                                            <Text>{formatDate(row.VRegDt)}</Text>
                                                        </Box>
                                                    </Td>
                                                    <Td>
                                                        <Box display="flex" flexDirection="column">
                                                            <Text>{row.VInsCompany}</Text>
                                                            <Text>{row.VInsNo}</Text>
                                                            <Text>{formatDate(row.VInsEndDt)}</Text>
                                                        </Box>
                                                    </Td>
                                                    <Td>{getStatus(row.Stat)}</Td>
                                                    <Td>
                                                        <VStack align="start" spacing={1}>
                                                            <Link href={`${backendUrl}/registraionV/${row.registrationPic}`} isExternal color="blue.500">
                                                                Registration
                                                            </Link>
                                                            <Link href={`${backendUrl}/engine/${row.enginePic}`} isExternal color="blue.500">
                                                                Engine
                                                            </Link>
                                                            <Link href={`${backendUrl}/insurance/${row.insurancePic}`} isExternal color="blue.500">
                                                                Insurance
                                                            </Link>
                                                        </VStack>
                                                    </Td>
                                                    <Td>
                                                        <IconButton
                                                            icon={<FaEdit />}
                                                            aria-label="Edit"
                                                            borderRadius="full"
                                                            onClick={() => handleEdit(row)}
                                                        />
                                                    </Td>
                                                </Tr>
                                            ))
                                        ) : (
                                            <Tr>
                                                <Td colSpan={4} px={2} py={1}>
                                                    <Text textAlign="center">No data found</Text>
                                                </Td>
                                            </Tr>
                                        )}
                                    </Tbody>
                                </Table>
                            </TableContainer>

                            <Box mt={6}>
                                <ReactPaginate
                                    previousLabel="Previous"
                                    nextLabel="Next"
                                    pageCount={pageCount}
                                    onPageChange={handlePageChange}
                                    containerClassName="pagination"
                                    activeClassName="active"
                                    pageClassName="page-item"
                                    previousClassName="page-item"
                                    nextClassName="page-item"
                                    breakClassName="page-item"
                                    pageLinkClassName="page-link"
                                    previousLinkClassName="page-link"
                                    nextLinkClassName="page-link"
                                    breakLinkClassName="page-link"
                                />
                            </Box>

                            <style>{`
                                            .pagination {
                                              display: flex;
                                              justify-content: center;
                                              list-style: none;
                                              padding: 0;
                                              margin-top: 1rem;
                                            }
                                            .page-item {
                                              margin: 0 5px;
                                            }
                                            .page-link {
                                              padding: 8px 12px;
                                              border-radius: 6px;
                                              background-color: #e2e8f0;
                                              cursor: pointer;
                                            }
                                            .page-link:hover {
                                              background-color: #cbd5e0;
                                            }
                                            .active .page-link {
                                              background-color: #3182ce;
                                              color: white;
                                            }
                                          `}</style>
                        </>
                    )}
                </Box>
                {/* Chakra UI Modal */}
                <Modal isOpen={isOpen} onClose={onClose} isCentered>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>Status</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            <form onSubmit={handleSubmit}>
                                <FormControl>
                                    <FormLabel>Status</FormLabel>
                                    <Select name="Stat" size="sm" onChange={handleChange} value={Stat} >
                                        <option value={0}>Select</option>
                                        <option value={5}>Approved</option>
                                        <option value={9}>Rejected</option>
                                    </Select>
                                </FormControl>
                                {reasionBlock && (
                                    <FormControl>
                                        <FormLabel>Reasion</FormLabel>
                                        <Select name="reasionId" size="sm" onChange={handleReasion} value={reasionId} >
                                            <option value={0}>Select</option>
                                            {
                                                reasionData.map((row, index) => (
                                                    <option key={row.rId} value={row.rId}>{row.name}</option>
                                                ))
                                            }

                                        </Select>
                                    </FormControl>
                                )}

                                <Button type="submit" mt={4} colorScheme="blue" size="sm">
                                    Update
                                </Button>
                            </form>
                        </ModalBody>

                    </ModalContent>
                </Modal>

            </Box>
        </AdminLayout>
    )
}

export default AdminVehicle
